class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    // Berry Tea : robuste aux reponses /cart/add au format "items" (Dealeasy envoie items[0][id]),
    // qui n'ont pas de "key" a la racine. Sans cela, getSectionInnerHTML plantait (null.innerHTML),
    // la notification ne s'ouvrait pas et la bulle du panier restait figee.
    const state = parsedState || {};
    const items = Array.isArray(state.items) ? state.items : [];
    const firstItem = items.length ? items[0] : null;
    this.cartItemKey = state.key || (firstItem && firstItem.key) || '';
    this.cartItemVariantId = state.variant_id || state.id || (firstItem && (firstItem.variant_id || firstItem.id)) || '';
    const sections = state.sections || {};

    this.getSectionsToRender().forEach((section) => {
      try {
        const target = document.getElementById(section.id);
        const html = sections[section.id];
        if (!target || typeof html !== 'string') return;
        let inner = this.getSectionInnerHTML(html, section.selector);
        if (inner === null && section.id === 'cart-notification-product') {
          inner = this.getSectionInnerHTML(
            html,
            this.cartItemVariantId
              ? `[id^="cart-notification-product-${this.cartItemVariantId}:"]`
              : '[id^="cart-notification-product-"]'
          );
        }
        if (inner !== null) target.innerHTML = inner;
      } catch (e) {
        console.warn('cart-notification: section non rendue', section.id, e);
      }
    });

    if (typeof sections['cart-icon-bubble'] !== 'string') this.refreshCartBubble();

    if (this.header) this.header.reveal();
    this.open();
  }

  refreshCartBubble() {
    const bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(`${root}?sections=cart-icon-bubble`)
      .then((response) => response.json())
      .then((data) => {
        const inner = data && data['cart-icon-bubble'] && this.getSectionInnerHTML(data['cart-icon-bubble']);
        if (inner !== null && inner !== undefined) bubble.innerHTML = inner;
      })
      .catch(() => {});
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const element = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return element ? element.innerHTML : null;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
